import {
    Component,
    OnInit,
    Input, OnDestroy,
} from '@angular/core';
import { DetailsConfig, SharedUiDetailsModule } from '@snelstart/ui-details';
import { ButtonConfiguration, SharedUiButtonModule } from '@snelstart/ui-button';
import {Observable, Subscription} from "rxjs";
import {BokkzAlgDataService, BokkzSbLogic, ClientEntity} from "@snelstart-ventures/fiscaal/domain-logic";
import { AangeverComponent } from '../schenking/aangever/aangever.component';
import { AkteComponent } from '../schenking/akte/akte.component';
import { AlgemeneVragenComponent } from '../schenking/algemene-vragen/algemene-vragen.component';
import { BorComponent } from '../schenking/bor/bor.component';
import { BelastingComponent } from '../schenking/belasting/belasting.component';
import { BerekeningComponent } from '../schenking/berekening/berekening.component';
import { ConserverendeAanslagComponent } from '../schenking/conserverende-aanslag/conserverende-aanslag.component';
import { ContactpersoonComponent } from '../schenking/contactpersoon/contactpersoon.component';
import { ContantenComponent } from '../schenking/contanten/contanten.component';
import { EffectenComponent } from '../schenking/effecten/effecten.component';
import { KwijtscheldingenComponent } from '../schenking/kwijtscheldingen/kwijtscheldingen.component';
import { OndernemingenComponent } from '../schenking/ondernemingen/ondernemingen.component';
import { OnroerendeZakenComponent } from '../schenking/onroerende-zaken/onroerende-zaken.component';
import { OverigeSchenkingenComponent } from '../schenking/overige-schenkingen/overige-schenkingen.component';
import { RoerendeZakenComponent } from '../schenking/roerende-zaken/roerende-zaken.component';
import { SchenkerComponent } from '../schenking/schenker/schenker.component';
import { SchuldigerkenningenComponent } from '../schenking/schuldigerkenningen/schuldigerkenningen.component';
import { UitkeringenComponent } from '../schenking/uitkeringen/uitkeringen.component';
import { VrijstellingenComponent } from '../schenking/vrijstellingen/vrijstellingen.component';
import { VruchtgebruikComponent } from '../schenking/vruchtgebruik/vruchtgebruik.component';
import { VoorkomingComponent } from '../schenking/voorkoming/voorkoming.component';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { TekstBelastingComponent } from '../schenking/toelichtingen-tekst/tekst-belasting/tekst-belasting.component';
import {
  TekstAlgemeneVragenComponent
} from '../schenking/toelichtingen-tekst/tekst-algemene-vragen/tekst-algemene-vragen.component';
import { TekstAkteComponent } from '../schenking/toelichtingen-tekst/tekst-akte/tekst-akte.component';
import { TekstAangeverComponent } from '../schenking/toelichtingen-tekst/tekst-aangever/tekst-aangever.component';
import { TekstBerekeningComponent } from '../schenking/toelichtingen-tekst/tekst-berekening/tekst-berekening.component';
import { TekstBorComponent } from '../schenking/toelichtingen-tekst/tekst-bor/tekst-bor.component';
import {
  TekstConserverendeAanslagComponent
} from '../schenking/toelichtingen-tekst/tekst-conserverende-aanslag/tekst-conserverende-aanslag.component';
import {
  TekstContactpersoonComponent
} from '../schenking/toelichtingen-tekst/tekst-contactpersoon/tekst-contactpersoon.component';
import { TekstContantenComponent } from '../schenking/toelichtingen-tekst/tekst-contanten/tekst-contanten.component';
import { TekstEffectenComponent } from '../schenking/toelichtingen-tekst/tekst-effecten/tekst-effecten.component';
import {
  TekstKwijtscheldingenComponent
} from '../schenking/toelichtingen-tekst/tekst-kwijtscheldingen/tekst-kwijtscheldingen.component';
import {
  TekstOndernemingenComponent
} from '../schenking/toelichtingen-tekst/tekst-ondernemingen/tekst-ondernemingen.component';
import {
  TekstOnroerendeZakenComponent
} from '../schenking/toelichtingen-tekst/tekst-onroerende-zaken/tekst-onroerende-zaken.component';
import {
  TekstOverigeSchenkingenComponent
} from '../schenking/toelichtingen-tekst/tekst-overige-schenkingen/tekst-overige-schenkingen.component';
import {
  TekstRoerendeZakenComponent
} from '../schenking/toelichtingen-tekst/tekst-roerende-zaken/tekst-roerende-zaken.component';
import { TekstSchenkerComponent } from '../schenking/toelichtingen-tekst/tekst-schenker/tekst-schenker.component';
import {
  TekstSchuldigerkenningenComponent
} from '../schenking/toelichtingen-tekst/tekst-schuldigerkenningen/tekst-schuldigerkenningen.component';
import {
  TekstUitkeringenComponent
} from '../schenking/toelichtingen-tekst/tekst-uitkeringen/tekst-uitkeringen.component';
import { TekstVoorkomingComponent } from '../schenking/toelichtingen-tekst/tekst-voorkoming/tekst-voorkoming.component';
import {
  TekstVrijstellingenComponent
} from '../schenking/toelichtingen-tekst/tekst-vrijstellingen/tekst-vrijstellingen.component';
import {
  TekstVruchtgebruikComponent
} from '../schenking/toelichtingen-tekst/tekst-vruchtgebruik/tekst-vruchtgebruik.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tax-donation-details',
  templateUrl: './feature-tax-donation-details.component.html',
  styleUrl: './feature-tax-donation-details.component.scss',
  imports: [
    CommonModule,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    AangeverComponent,
    AkteComponent,
    AlgemeneVragenComponent,
    BorComponent,
    BelastingComponent,
    BerekeningComponent,
    ConserverendeAanslagComponent,
    ContactpersoonComponent,
    ContantenComponent,
    EffectenComponent,
    KwijtscheldingenComponent,
    OndernemingenComponent,
    OnroerendeZakenComponent,
    OverigeSchenkingenComponent,
    RoerendeZakenComponent,
    SchenkerComponent,
    SchuldigerkenningenComponent,
    UitkeringenComponent,
    VrijstellingenComponent,
    VruchtgebruikComponent,
    VoorkomingComponent,
    SharedUiDialogModule,
    TekstBelastingComponent,
    TekstAlgemeneVragenComponent,
    TekstAkteComponent,
    TekstAangeverComponent,
    TekstBerekeningComponent,
    TekstBorComponent,
    TekstConserverendeAanslagComponent,
    TekstContactpersoonComponent,
    TekstContantenComponent,
    TekstEffectenComponent,
    TekstKwijtscheldingenComponent,
    TekstOndernemingenComponent,
    TekstOnroerendeZakenComponent,
    TekstOverigeSchenkingenComponent,
    TekstRoerendeZakenComponent,
    TekstSchenkerComponent,
    TekstSchuldigerkenningenComponent,
    TekstUitkeringenComponent,
    TekstVoorkomingComponent,
    TekstVrijstellingenComponent,
    TekstVruchtgebruikComponent
  ]
})
export class FeatureTaxDonationDetailsComponent implements OnInit, OnDestroy {

    @Input() public id!: string;
    private clientEntitySubscription: Subscription | undefined;
    public clientEntity = {} as ClientEntity;
    public detailsConfig = {} as DetailsConfig;

    dialogInfoVisible = false;

    showButtonInfo(id: string): boolean {
        const toegestaneIds: string[] = [
            'Ontvanger',
            'Notariële akte',
            'Algemene vragen',
            'Bedrijfsopvolgingsregeling',
            'Schenkbelasting',
            'Berekening',
            'Conserverende aanslag',
            'Contactpersoon',
            'Contanten',
            'Effecten',
            'Kwijtscheldingen',
            'Ondernemingen',
            'Onroerende zaken',
            'Overige schenkingen',
            'Roerende zaken',
            'Schenker',
            'Schenking op papier',
            'Periodieke uitkeringen',
            'Vrijstellingen',
            'Vruchtgebruiken',
            'Voorkoming dubbele schenkbelasting'
        ];
        return toegestaneIds.includes(id);
    }

    showDialogInfo() {
        this.dialogInfoVisible = true;
    }

    constructor(public logicService: BokkzSbLogic,
                private algDataService: BokkzAlgDataService) {
        this.detailsConfig = DetailsConfig.create({hideArrowButtons: true});
    }

    ngOnInit(): void {
        this.detailsConfig = DetailsConfig.create({hideArrowButtons: true});
        this.clientEntitySubscription = this.algDataService.client.subscribe((value) => {
            this.clientEntity = value;
        })
    }

    ngOnDestroy(): void {
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe()
        }
    }

    config() {
        return ButtonConfiguration.create({
            onClick: () =>
                new Observable((subscription) => {
                    setTimeout(() => {
                        subscription.next(true);
                        subscription.complete();
                        this.saveForm()
                    }, 200);
                }),
        })
    }

    saveForm(): void {
        setTimeout(() => {
            this.logicService.postGiftTaxEntity(String(this.clientEntity.sstRelationId), false);
        }, 50)
    }
}
